/* MTG_HOURS_ONE_AT_A_TIME + brands sub light black */
(function () {
  function syncHours() {
    var root = document.querySelector('[id^="MamaGlassHeader-"]');
    if (!root) return;
    var items = root.querySelectorAll('.mgh-hours-item');
    if (!items.length) return;
    var active = -1;
    items.forEach(function (item, i) {
      if (item.classList.contains('is-active')) active = i;
    });
    if (active < 0) active = 0;
    items.forEach(function (item, i) {
      var on = i === active;
      item.classList.toggle('is-active', on);
      item.style.setProperty('display', on ? 'block' : 'none', 'important');
      item.style.setProperty('opacity', on ? '1' : '0', 'important');
      item.style.setProperty('visibility', on ? 'visible' : 'hidden', 'important');
    });
  }

  function ensureBrandsSubBlack() {
    if (document.getElementById('mtg-brands-sub-light-style')) return;
    var s = document.createElement('style');
    s.id = 'mtg-brands-sub-light-style';
    s.textContent = [
      '#CosmeticFlexWidget-announcement_njATan .cfxw__brandsSub,',
      'html:not(.dark-mode) .cfxw__brandsSub,',
      'body:not(.dark-mode) .cfxw__brandsSub{',
      'color:#111111!important;',
      '-webkit-text-fill-color:#111111!important;',
      '}',
      'html.dark-mode .cfxw__brandsSub,',
      'body.dark-mode .cfxw__brandsSub,',
      '.dark-mode .cfxw__brandsSub{',
      'color:rgba(255,255,255,.9)!important;',
      '-webkit-text-fill-color:rgba(255,255,255,.9)!important;',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  function boot() {
    ensureBrandsSubBlack();
    syncHours();
    setInterval(syncHours, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
